<template>
      <div class="hello">
          <h1>404 Not Found</h1>
          <legend>即将跳转至首页...</legend>
      </div>
</template>

<script type="text/babel">

export default {
    name: 'not-found',
    data () {
        return {

        }
    },
    methods: {

    },
    created() {
        setTimeout(function(){
            location.href = '/';
        },3000)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}

.hello {
    padding: 120px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/NotFound.vue